import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { WarehouseStockState } from "@WhiteCap/Store/Reducer/WhiteCapReducer/StockWarehouseReducer";

type ExtendedWarehouseStockState = WarehouseStockState & {
    callApi?: boolean; 
};

type HandlerType = CustomApiHandler<ExtendedWarehouseStockState>;

export const HandleWarehouseStockChange: HandlerType = props => {
    const { productId = "", isStockAvailable = true } = props.parameter;

    props.dispatch({
        type: "Custom/WarehouseStock/SetWarehouseStockState",
        data: { productId, isStockAvailable },
    });
};

export const MaybeLoadWarehousesHandler: HandlerType = props => {
    if (!props.parameter.callApi) {return;}

    const state = props.getState();
    const parameters = state.components.findLocationModal.getWarehousesParameter;

    props.dispatch(loadWarehouses(parameters));
};

export const chain = [HandleWarehouseStockChange, MaybeLoadWarehousesHandler];

const setWarehouseStock = createHandlerChainRunner(chain, "SetWarehouseStockCombined");
export default setWarehouseStock;
